<template>
  <div class="p-3 client-side-tabs">
    <c-tabs variant="pills" vertical>
      <c-tab active title="SMTP">
        <smtp :organisation="organisation"></smtp>
      </c-tab>
      <c-tab title="Content">
        <email-content :organisation="organisation"></email-content>
      </c-tab>
    </c-tabs>
  </div>
</template>

<script>
// import { Tabs, TabPane } from 'vue-bulma-tabs'
import Smtp from './smtp';
import EmailContent from './content';

export default {
  components: {
    Smtp,
    EmailContent,
    // Tabs,
    // TabPane
  },

  props: {
    organisation: Object,
  },

  data() {
    return {};
  },
  methods: {},
};
</script>

<style lang="scss" scoped="">
.c-dark-theme {
  .client-side-tabs {
    background-color: #23242d;
  }
}
</style>
